<template>
    <div :class="{'modal': true, 'hide': !modalStatus}" id="modal">
        <div class="wrapper">
            <div class="header">
                {{ modalTitle }}
            </div>
            <div class="content">
                {{ modalMessage }}
            </div>
            <div class="footer">
                <button @click="handleClickOkButton" class="btn font-opensans">OK</button>
            </div>
        </div>
    </div>
</template>

<script>

import { mapState } from 'vuex'

export default {
    name: 'Modal',

    methods: {

        handleClickOkButton: function () {

            this.$store.commit('toggleMainModal', false)
        }
    },

    computed: mapState({
        modalStatus: state => state.modal.main.isOpen,
        modalTitle: state => state.modal.main.title,
        modalMessage: state => state.modal.main.message
    })
}
</script>
